module.exports = __webpack_public_path__ + "static/media/mensagem-enviada.4036d8e9.png";